import styled from 'styled-components';

export const HeaderContainer = styled.div`
  margin: 0 1em;
  display: flex;
  flex-direction: column;
  gap: 1em;

  @media ${({ theme }) => theme.queries.minDesktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75em;

  button {
    width: 100%;
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    flex-direction: row;

    button {
      width: auto;
    }
  }
`;

export const Content = styled.div`
  margin: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 32px;
  margin-bottom: 32px;
`;
